
export enum PaymentType {
  None = 0,
  Cash = 1,
  CreditCard = 2,
  Instant = 3,
  Check = 4,
  WireTransfer = 5,
  Voucher = 6,
  Other = 7,
  Presentation = 100,
}


export interface Payment {
  type: PaymentType;
  amount: number;
  transaction?: any;
}

export enum TransactionStatus {
  Canceled = 1,
  Declined = 2,
  Failed = 3,
  Success = 0
}
export interface Transaction {
  date: string;
  PAN: string;
  obfuscatedPAN: string;
  status: TransactionStatus;
  statusText: string;
  cardBrand: string;
  responseCode: string;
  authorizationCode: string;
  aid: string;
  tsi: string;
  tvr: string;
  stan: string;
  cvm: string;
  tid: string;
  updatePending: boolean;
  amount: number;
  mid: string;
  rrn: string;
  apn: string;
  cvmr: string;
  batchNumber: string;
  transactionNumber: string;
  transactionType: string;
  referenceNumber: string;
  isContactless: boolean;
  /** Globalno jedinstven ID native zapisa — ide uz charge za idempotentan server ledger upis. */
  recordUID?: string;
  /** Sanitizovan pun sirovi odgovor provajdera (JSON) — ide uz charge u server ledger RawJson. */
  rawResponse?: string;
  /** Naziv integracije/provajdera — ide uz charge za katalog transakcija na serveru. */
  provider?: string;
}
